module.exports = __webpack_public_path__ + "img/clipboard (1).ae7636eb.webp";